// extracted by mini-css-extract-plugin
export default {"page":"lW","headerwrap":"mW","headerblock":"nW","textwrapper":"oW","text":"pW","closerlook":"qW","arrowwrap":"rW","icon":"sW","updown":"tW","products":"uW","system":"vW","systemimage":"wW","cards":"xW","note":"yW","fadein":"zW"};
    if(module.hot) {
      // 1726593107534
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  